<script setup lang="js">
const props = defineProps({
  labels: {
    type: Object,
    required: true,
  },
  loading_gif: {
    type: String,
    required: true,
  },
});

// If not exists, use the default from DATAAGENT_INSIGHTS.
const labels = props.labels || window.DATAAGENT_INSIGHTS.labels;
const loading_gif = props.loading_gif || window.DATAAGENT_INSIGHTS.loading_gif;
</script>
<template>
  <div class="da:flex da:flex-col da:justify-center da:items-center">
    <img :src="loading_gif" :alt="labels.loading" />
  </div>
</template>
